module.exports = __webpack_public_path__ + "static/img/response3.5d14910.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/response3.png
// module id = Zel1
// module chunks = 0